import { createRequestTypes } from 'common/websocket-redux';

export const REQUEST_RESUBMIT_INTERAC_PAYMENT = createRequestTypes(
  'script-helpers/RESUBMIT_INTERAC_PAYMENT',
);
